export default "__VITE_ASSET__DHcpaMlp__"